import { Profile } from 'oidc-client';
import React from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import Routes from '../../config/routes';
import { ActionType, ModuleName } from '../../core/models/enum';
import { authorizeAction } from '../../helpers/CheckPermissionHelper';
import { AuthorizationRoutes, QueryParameterNames } from './ApiAuthorizationConstants';
import authService from './AuthorizeService';

interface Props {
    exact?: any;
    component: any;
    path: any;
    moduleName: ModuleName;
    location?: any;
}

interface State {
    ready: boolean;
    userProfile?: Profile;
    authorized?: boolean;
}

export default class AuthorizeRoute extends React.Component<Props, State> {
    _subscription: any;

    constructor(props: Props) {
        super(props);

        this.state = {
            ready: false,
            userProfile: undefined,
            authorized: undefined,
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentDidUpdate(prevProps: Props) {        
        const { moduleName } = this.props;

        if (moduleName !== prevProps.moduleName) {
            this.initSession();
        }
    }

    initSession = () => {
        const { moduleName } = this.props;
        const { userProfile } = this.state;

        const {
            location: { pathname },
        } = window;
        const urlParts = pathname.split('/');

        if (urlParts.length === 0) return;

        const lastPart = urlParts.pop();

        let actionType: ActionType = ActionType.Read;

        switch (lastPart) {
            case 'edit':
                actionType = ActionType.Update;
                break;
            case 'create':
                actionType = ActionType.Create;
                break;
            default:
                break;
        }

        if (!userProfile) {
            return;
        }

        const authorized = authorizeAction(userProfile, moduleName, actionType);

        this.setState({
            authorized,
        });
    };

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    render() {
        const { ready, userProfile, authorized } = this.state;
        var link = document.createElement('a');
        link.href = this.props.location.pathname;
        const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
        const redirectUrl = `${AuthorizationRoutes.Login}?${
            QueryParameterNames.ReturnUrl
        }=${encodeURI(returnUrl)}`;
        if (!ready) {
            return <div></div>;
        } else {
            const { component: Component, ...rest } = this.props;
            return (
                <Route
                    {...rest}
                    render={(props: RouteComponentProps) => {
                        if (!userProfile) {
                            return <Redirect to={redirectUrl} />;
                        }
                        if (authorized === undefined) {
                            return <div />;
                        }
                        if (authorized === false) {
                            return <Redirect to={Routes.ROUTE_NOT_FOUND} />;
                        }
                        return <Component {...props} userProfile={userProfile} />;
                    }}
                />
            );
        }
    }

    async populateAuthenticationState() {
        const userProfile = await authService.getUserProfile();
        this.setState({ ready: true, userProfile }, () => this.initSession());
    }

    async authenticationChanged() {
        this.setState({ ready: false, userProfile: undefined });
        await this.populateAuthenticationState();
    }
}
